// Services Data - Full Salon Services for BLR Nail Club
// Categories: Hair, Skin, Body, Personal Grooming, Bridal

export const serviceCategories = [
  {
    id: 'hair',
    name: 'Hair',
    slug: 'hair',
    description: 'Expert hair styling services from cuts to color transformations',
    image: 'https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg?auto=compress&cs=tinysrgb&w=800',
    subCategories: [
      {
        id: 'women-haircut-and-style',
        name: "Women's Cut & Style",
        slug: 'women-haircut-and-style',
        description: 'Expert haircuts and styling tailored to your features',
        image: 'https://images.pexels.com/photos/3993449/pexels-photo-3993449.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Women Haircut', price: 'Rs. 800', duration: '45 mins' },
          { name: 'Haircut with Wash & Blow Dry', price: 'Rs. 1,200', duration: '60 mins' },
          { name: 'Layered Cut', price: 'Rs. 1,500', duration: '60 mins' },
          { name: 'Fringe/Bangs Cut', price: 'Rs. 400', duration: '20 mins' },
          { name: 'Blow Dry & Styling', price: 'Rs. 600', duration: '30 mins' }
        ]
      },
      {
        id: 'hair-treatments',
        name: 'Hair Treatments',
        slug: 'hair-treatments',
        description: 'Deep nourishing treatments for healthier, stronger hair',
        image: 'https://images.pexels.com/photos/3993448/pexels-photo-3993448.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Hair Spa', price: 'Rs. 1,500', duration: '60 mins' },
          { name: 'Keratin Treatment', price: 'Rs. 5,000', duration: '120 mins' },
          { name: 'Hair Botox', price: 'Rs. 4,000', duration: '90 mins' },
          { name: 'Olaplex Treatment', price: 'Rs. 2,500', duration: '45 mins' },
          { name: 'Deep Conditioning', price: 'Rs. 1,000', duration: '30 mins' }
        ]
      },
      {
        id: 'hair-colour',
        name: 'Hair Colour',
        slug: 'hair-colour',
        description: 'Expert hair coloring from subtle highlights to bold transformations',
        image: 'https://images.pexels.com/photos/3993447/pexels-photo-3993447.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Global Hair Colour', price: 'Rs. 2,500', duration: '90 mins' },
          { name: 'Root Touch Up', price: 'Rs. 1,500', duration: '60 mins' },
          { name: 'Highlights/Lowlights', price: 'Rs. 3,500', duration: '120 mins' },
          { name: 'Balayage', price: 'Rs. 5,000', duration: '150 mins' },
          { name: 'Ombre', price: 'Rs. 4,500', duration: '120 mins' },
          { name: 'Creative Colour', price: 'Rs. 7,000', duration: '180 mins' }
        ]
      },
      {
        id: 'hair-smoothening',
        name: 'Hair Smoothening',
        slug: 'hair-smoothening',
        description: 'Say goodbye to frizz with sleek, smooth finishes',
        image: 'https://images.pexels.com/photos/3993446/pexels-photo-3993446.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: false,
        services: [
          { name: 'Keratin Smoothening', price: 'Rs. 6,000', duration: '180 mins' },
          { name: 'Brazilian Blowout', price: 'Rs. 8,000', duration: '180 mins' },
          { name: 'Permanent Straightening', price: 'Rs. 7,000', duration: '240 mins' },
          { name: 'Anti-Frizz Treatment', price: 'Rs. 3,000', duration: '90 mins' }
        ]
      },
      {
        id: 'men-haircut-and-style',
        name: "Men's Cut & Style",
        slug: 'men-haircut-and-style',
        description: 'Sharp, sophisticated cuts for the modern man',
        image: 'https://images.pexels.com/photos/1813272/pexels-photo-1813272.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: false,
        services: [
          { name: 'Men Haircut', price: 'Rs. 500', duration: '30 mins' },
          { name: 'Haircut with Beard Trim', price: 'Rs. 700', duration: '45 mins' },
          { name: 'Fade Cut', price: 'Rs. 600', duration: '35 mins' },
          { name: 'Beard Styling', price: 'Rs. 300', duration: '20 mins' }
        ]
      }
    ]
  },
  {
    id: 'skin',
    name: 'Skin',
    slug: 'skin',
    description: 'Advanced skin treatments for radiant, healthy skin',
    image: 'https://images.pexels.com/photos/3985330/pexels-photo-3985330.jpeg?auto=compress&cs=tinysrgb&w=800',
    subCategories: [
      {
        id: 'radiant-skin',
        name: 'Radiant Skin',
        slug: 'radiant-skin',
        description: 'Facials and treatments for glowing, luminous skin',
        image: 'https://images.pexels.com/photos/3985330/pexels-photo-3985330.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Classic Facial', price: 'Rs. 1,500', duration: '60 mins' },
          { name: 'Hydrating Facial', price: 'Rs. 2,000', duration: '60 mins' },
          { name: 'Gold Facial', price: 'Rs. 2,500', duration: '75 mins' },
          { name: 'Diamond Facial', price: 'Rs. 3,000', duration: '75 mins' },
          { name: 'HydraFacial', price: 'Rs. 3,500', duration: '60 mins' },
          { name: 'Oxygen Facial', price: 'Rs. 4,000', duration: '75 mins' }
        ]
      },
      {
        id: 'acne-treatment',
        name: 'Acne & Acne Marks',
        slug: 'acne-treatment',
        description: 'Targeted treatments for acne-prone skin',
        image: 'https://images.pexels.com/photos/3985331/pexels-photo-3985331.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Acne Control Facial', price: 'Rs. 2,000', duration: '60 mins' },
          { name: 'Chemical Peel', price: 'Rs. 2,500', duration: '45 mins' },
          { name: 'Microdermabrasion', price: 'Rs. 3,000', duration: '45 mins' },
          { name: 'LED Light Therapy', price: 'Rs. 1,500', duration: '30 mins' }
        ]
      },
      {
        id: 'de-pigmentation',
        name: 'De-pigmentation',
        slug: 'de-pigmentation',
        description: 'Treatments for even-toned, bright skin',
        image: 'https://images.pexels.com/photos/3985332/pexels-photo-3985332.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Brightening Facial', price: 'Rs. 2,500', duration: '60 mins' },
          { name: 'Vitamin C Treatment', price: 'Rs. 3,000', duration: '60 mins' },
          { name: 'Pigmentation Peel', price: 'Rs. 3,500', duration: '45 mins' },
          { name: 'BB Glow Treatment', price: 'Rs. 5,000', duration: '90 mins' }
        ]
      },
      {
        id: 'anti-ageing',
        name: 'Anti-Ageing',
        slug: 'anti-ageing',
        description: 'Turn back the clock with advanced anti-aging treatments',
        image: 'https://images.pexels.com/photos/3985333/pexels-photo-3985333.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Anti-Ageing Facial', price: 'Rs. 3,500', duration: '75 mins' },
          { name: 'Collagen Boost Treatment', price: 'Rs. 4,000', duration: '60 mins' },
          { name: 'Microneedling', price: 'Rs. 5,000', duration: '60 mins' },
          { name: 'Skin Tightening', price: 'Rs. 6,000', duration: '60 mins' }
        ]
      },
      {
        id: 'clean-up',
        name: 'Clean Up',
        slug: 'clean-up',
        description: 'Quick refresh for cleaner, clearer skin',
        image: 'https://images.pexels.com/photos/3985334/pexels-photo-3985334.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: false,
        services: [
          { name: 'Basic Clean Up', price: 'Rs. 800', duration: '30 mins' },
          { name: 'Deep Cleansing', price: 'Rs. 1,200', duration: '45 mins' },
          { name: 'Fruit Clean Up', price: 'Rs. 1,000', duration: '35 mins' }
        ]
      }
    ]
  },
  {
    id: 'body',
    name: 'Body',
    slug: 'body',
    description: 'Relaxing spa treatments and body therapies',
    image: 'https://images.pexels.com/photos/3757952/pexels-photo-3757952.jpeg?auto=compress&cs=tinysrgb&w=800',
    subCategories: [
      {
        id: 'massage-therapies',
        name: 'Massage Therapies',
        slug: 'massage-therapies',
        description: 'Therapeutic massages for ultimate relaxation',
        image: 'https://images.pexels.com/photos/3757952/pexels-photo-3757952.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Swedish Massage', price: 'Rs. 2,500', duration: '60 mins' },
          { name: 'Deep Tissue Massage', price: 'Rs. 3,000', duration: '60 mins' },
          { name: 'Aromatherapy Massage', price: 'Rs. 3,500', duration: '75 mins' },
          { name: 'Hot Stone Massage', price: 'Rs. 4,000', duration: '90 mins' },
          { name: 'Thai Massage', price: 'Rs. 3,500', duration: '90 mins' }
        ]
      },
      {
        id: 'spa-treatments',
        name: 'Spa Treatments',
        slug: 'spa-treatments',
        description: 'Luxurious spa experiences for body and mind',
        image: 'https://images.pexels.com/photos/3757954/pexels-photo-3757954.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Body Polish', price: 'Rs. 2,500', duration: '60 mins' },
          { name: 'Body Wrap', price: 'Rs. 3,000', duration: '75 mins' },
          { name: 'Detox Treatment', price: 'Rs. 3,500', duration: '90 mins' },
          { name: 'Signature Spa Ritual', price: 'Rs. 5,000', duration: '120 mins' }
        ]
      },
      {
        id: 'scrubs-and-wraps',
        name: 'Scrubs & Wraps',
        slug: 'scrubs-and-wraps',
        description: 'Exfoliating and hydrating body treatments',
        image: 'https://images.pexels.com/photos/3757955/pexels-photo-3757955.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Coffee Scrub', price: 'Rs. 1,500', duration: '45 mins' },
          { name: 'Salt Scrub', price: 'Rs. 1,500', duration: '45 mins' },
          { name: 'Sugar Scrub', price: 'Rs. 1,500', duration: '45 mins' },
          { name: 'Mud Wrap', price: 'Rs. 2,500', duration: '60 mins' },
          { name: 'Seaweed Wrap', price: 'Rs. 3,000', duration: '60 mins' }
        ]
      }
    ]
  },
  {
    id: 'grooming',
    name: 'Personal Grooming',
    slug: 'grooming',
    description: 'Complete grooming services for a polished look',
    image: 'https://images.pexels.com/photos/3997391/pexels-photo-3997391.jpeg?auto=compress&cs=tinysrgb&w=800',
    subCategories: [
      {
        id: 'manicure-pedicure',
        name: 'Manicure & Pedicure',
        slug: 'manicure-pedicure',
        description: 'Luxurious hand and foot care treatments',
        image: 'https://images.pexels.com/photos/3997390/pexels-photo-3997390.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Classic Manicure', price: 'Rs. 500', duration: '30 mins' },
          { name: 'Classic Pedicure', price: 'Rs. 700', duration: '45 mins' },
          { name: 'Spa Manicure', price: 'Rs. 1,000', duration: '45 mins' },
          { name: 'Spa Pedicure', price: 'Rs. 1,200', duration: '60 mins' },
          { name: 'Gel Manicure', price: 'Rs. 1,500', duration: '60 mins' },
          { name: 'Gel Pedicure', price: 'Rs. 1,800', duration: '75 mins' },
          { name: 'Luxury Manicure', price: 'Rs. 2,000', duration: '75 mins' },
          { name: 'Luxury Pedicure', price: 'Rs. 2,500', duration: '90 mins' }
        ]
      },
      {
        id: 'nail-bar',
        name: 'Nail Bar',
        slug: 'nail-bar',
        description: 'Expert nail extensions, art, and enhancements',
        image: 'https://images.pexels.com/photos/3997391/pexels-photo-3997391.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Gel Polish', price: 'Rs. 800', duration: '45 mins' },
          { name: 'Gel Extensions', price: 'Rs. 2,000', duration: '90 mins' },
          { name: 'Acrylic Extensions', price: 'Rs. 2,500', duration: '120 mins' },
          { name: 'Nail Art (per nail)', price: 'Rs. 100', duration: '15 mins' },
          { name: 'Chrome/Mirror Nails', price: 'Rs. 500', duration: '30 mins' },
          { name: 'French Tips', price: 'Rs. 300', duration: '20 mins' },
          { name: 'Nail Repair', price: 'Rs. 200', duration: '15 mins' },
          { name: 'Gel Removal', price: 'Rs. 300', duration: '30 mins' }
        ]
      },
      {
        id: 'waxing',
        name: 'Waxing & Threading',
        slug: 'waxing',
        description: 'Smooth, hair-free skin with expert waxing services',
        image: 'https://images.pexels.com/photos/3997388/pexels-photo-3997388.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Full Arms Wax', price: 'Rs. 400', duration: '20 mins' },
          { name: 'Full Legs Wax', price: 'Rs. 600', duration: '30 mins' },
          { name: 'Underarms Wax', price: 'Rs. 150', duration: '10 mins' },
          { name: 'Full Body Wax', price: 'Rs. 2,000', duration: '90 mins' },
          { name: 'Bikini Wax', price: 'Rs. 800', duration: '30 mins' },
          { name: 'Brazilian Wax', price: 'Rs. 1,500', duration: '45 mins' },
          { name: 'Eyebrow Threading', price: 'Rs. 50', duration: '10 mins' },
          { name: 'Upper Lip Threading', price: 'Rs. 30', duration: '5 mins' },
          { name: 'Full Face Threading', price: 'Rs. 150', duration: '20 mins' }
        ]
      },
      {
        id: 'eyelash-extensions',
        name: 'Eyelash Extensions',
        slug: 'eyelash-extensions',
        description: 'Wake up with perfect lashes every day',
        image: 'https://images.pexels.com/photos/3985329/pexels-photo-3985329.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Classic Lash Extensions', price: 'Rs. 2,500', duration: '90 mins' },
          { name: 'Volume Lash Extensions', price: 'Rs. 3,500', duration: '120 mins' },
          { name: 'Hybrid Lash Extensions', price: 'Rs. 3,000', duration: '105 mins' },
          { name: 'Mega Volume Lashes', price: 'Rs. 4,500', duration: '150 mins' },
          { name: 'Lash Lift & Tint', price: 'Rs. 2,000', duration: '60 mins' },
          { name: 'Lash Refill', price: 'Rs. 1,500', duration: '60 mins' },
          { name: 'Lash Removal', price: 'Rs. 500', duration: '30 mins' }
        ]
      },
      {
        id: 'semi-permanent-makeup',
        name: 'Semi-Permanent Makeup',
        slug: 'semi-permanent-makeup',
        description: 'Wake up beautiful with PMU services',
        image: 'https://images.pexels.com/photos/3993293/pexels-photo-3993293.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Microblading', price: 'Rs. 8,000', duration: '180 mins' },
          { name: 'Ombre Brows', price: 'Rs. 10,000', duration: '180 mins' },
          { name: 'Lip Blush', price: 'Rs. 12,000', duration: '180 mins' },
          { name: 'Permanent Eyeliner', price: 'Rs. 8,000', duration: '120 mins' },
          { name: 'PMU Touch Up', price: 'Rs. 3,000', duration: '90 mins' }
        ]
      }
    ]
  },
  {
    id: 'bridal',
    name: 'Bridal',
    slug: 'bridal',
    description: 'Complete bridal beauty packages for your special day',
    image: 'https://images.pexels.com/photos/1024993/pexels-photo-1024993.jpeg?auto=compress&cs=tinysrgb&w=800',
    subCategories: [
      {
        id: 'pre-bridal',
        name: 'Pre-Bridal',
        slug: 'pre-bridal',
        description: 'Prepare for your big day with our pre-bridal packages',
        image: 'https://images.pexels.com/photos/1024993/pexels-photo-1024993.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Pre-Bridal Facial Package (4 sessions)', price: 'Rs. 8,000', duration: '4 x 60 mins' },
          { name: 'Body Polishing Package', price: 'Rs. 6,000', duration: '3 x 60 mins' },
          { name: 'Full Body Wax Package', price: 'Rs. 4,000', duration: '2 sessions' },
          { name: 'Hair Treatment Package', price: 'Rs. 5,000', duration: '2 x 90 mins' },
          { name: 'Complete Pre-Bridal Package', price: 'Rs. 25,000', duration: 'Multiple sessions' }
        ]
      },
      {
        id: 'bridal-makeup',
        name: 'Bridal Makeup',
        slug: 'bridal-makeup',
        description: 'Stunning bridal looks for your special day',
        image: 'https://images.pexels.com/photos/1024994/pexels-photo-1024994.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'HD Bridal Makeup', price: 'Rs. 15,000', duration: '120 mins' },
          { name: 'Airbrush Bridal Makeup', price: 'Rs. 20,000', duration: '150 mins' },
          { name: 'Bridal Hair Styling', price: 'Rs. 5,000', duration: '90 mins' },
          { name: 'Bridal Draping', price: 'Rs. 3,000', duration: '45 mins' },
          { name: 'Complete Bridal Package', price: 'Rs. 35,000', duration: 'Full Day' }
        ]
      },
      {
        id: 'party-makeup',
        name: 'Party Makeup',
        slug: 'party-makeup',
        description: 'Look stunning for any occasion',
        image: 'https://images.pexels.com/photos/1024995/pexels-photo-1024995.jpeg?auto=compress&cs=tinysrgb&w=800',
        trending: true,
        services: [
          { name: 'Party Makeup', price: 'Rs. 3,000', duration: '60 mins' },
          { name: 'Cocktail Makeup', price: 'Rs. 5,000', duration: '75 mins' },
          { name: 'Engagement Makeup', price: 'Rs. 8,000', duration: '90 mins' },
          { name: 'Reception Makeup', price: 'Rs. 10,000', duration: '90 mins' }
        ]
      }
    ]
  }
];

// Get all sub-categories flattened
export const getAllSubCategories = () => {
  return serviceCategories.flatMap(cat => 
    cat.subCategories.map(sub => ({
      ...sub,
      parentCategory: cat.name,
      parentSlug: cat.slug
    }))
  );
};

// Get category by slug
export const getCategoryBySlug = (slug) => {
  return serviceCategories.find(cat => cat.slug === slug);
};

// Get sub-category by slug
export const getSubCategoryBySlug = (slug) => {
  for (const category of serviceCategories) {
    const subCat = category.subCategories.find(s => s.slug === slug);
    if (subCat) {
      return { ...subCat, parentCategory: category.name, parentSlug: category.slug };
    }
  }
  return null;
};

// Search services
export const searchServices = (query) => {
  const lowercaseQuery = query.toLowerCase();
  const results = [];
  
  serviceCategories.forEach(cat => {
    cat.subCategories.forEach(subCat => {
      if (subCat.name.toLowerCase().includes(lowercaseQuery) ||
          subCat.description.toLowerCase().includes(lowercaseQuery)) {
        results.push({
          ...subCat,
          parentCategory: cat.name,
          parentSlug: cat.slug
        });
      }
      subCat.services.forEach(service => {
        if (service.name.toLowerCase().includes(lowercaseQuery)) {
          if (!results.find(r => r.slug === subCat.slug)) {
            results.push({
              ...subCat,
              parentCategory: cat.name,
              parentSlug: cat.slug
            });
          }
        }
      });
    });
  });
  
  return results;
};

// Get all services flat list
export const getAllServices = () => {
  const allServices = [];
  serviceCategories.forEach(cat => {
    cat.subCategories.forEach(subCat => {
      subCat.services.forEach(service => {
        allServices.push({
          ...service,
          subCategory: subCat.name,
          subCategorySlug: subCat.slug,
          category: cat.name,
          categorySlug: cat.slug,
          image: subCat.image
        });
      });
    });
  });
  return allServices;
};

// Legacy exports for backward compatibility
export const servicesData = getAllServices();
export const getServiceBySlug = getSubCategoryBySlug;
export const getServicesByCategory = (categorySlug) => {
  const category = getCategoryBySlug(categorySlug);
  return category ? category.subCategories : [];
};
